var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.isManager
    ? _c("div", { staticClass: "container-renwu" }, [
        _c("div", { staticClass: "tabs" }, [
          _c("div", { staticClass: "tab select" }, [_vm._v("打卡带看")]),
          _vm._v(" "),
          _c("div", { staticClass: "tab", on: { click: _vm.gotoRenwu } }, [
            _vm._v("带看任务"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "select-type" }, [
          _c("span", [_vm._v("选择类型")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.type,
                    expression: "type",
                  },
                ],
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.type = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { selected: "", value: "1" } }, [
                  _vm._v("新房"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { selected: "", value: "2" } }, [
                  _vm._v("二手房"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "3" } }, [_vm._v("租房")]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "select-type" }, [
          _c("span", [_vm._v("打卡方式")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.method,
                    expression: "method",
                  },
                ],
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.method = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { selected: "", value: "1" } }, [
                  _vm._v("本人带看打卡"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "2" } }, [
                  _vm._v("替人带看打卡"),
                ]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-phone" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dk_method,
                  expression: "dk_method",
                },
              ],
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.dk_method = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { attrs: { selected: "", value: "phone" } }, [
                _vm._v("手机号"),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "bianhao" } }, [
                _vm._v("客户编号"),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.dk_method == "phone"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.phone,
                    expression: "phone",
                  },
                ],
                attrs: { type: "text", placeholder: "请输入客户手机号" },
                domProps: { value: _vm.phone },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.phone = $event.target.value
                    },
                    function ($event) {
                      return _vm.inputChangePhone($event)
                    },
                  ],
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.dk_method == "bianhao"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.phone,
                    expression: "phone",
                  },
                ],
                attrs: { type: "text", placeholder: "请输入客源编号" },
                domProps: { value: _vm.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.phone = $event.target.value
                  },
                },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.dk_method == "phone" && _vm.keyuanNum != null
          ? _c("div", { staticClass: "select-type" }, [
              _c("span", [_vm._v("客源编号")]),
              _vm._v(" "),
              _c("div", { staticClass: "control" }, [
                _vm._v("\n      " + _vm._s(_vm.keyuanNum) + "\n    "),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.method == 2
          ? _c("div", { staticClass: "from-item" }, [
              _c("span", { staticClass: "from-lable" }, [_vm._v("替看人")]),
              _vm._v(" "),
              _c("div", { staticClass: "from-control" }, [
                _c("input", {
                  attrs: { type: "text", placeholder: "请输入经纪人姓名" },
                  domProps: { value: _vm.name },
                  on: {
                    input: function ($event) {
                      return _vm.inputChange($event)
                    },
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.method == 2 && _vm.list.length > 0
          ? _c(
              "div",
              { staticClass: "list" },
              _vm._l(_vm.list, function (item) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass: "item",
                    on: {
                      click: function ($event) {
                        return _vm.select(item)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "name" }, [
                      _vm._v(_vm._s(item.login_name)),
                    ]),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "btn-commit", on: { click: _vm.commit } }, [
          _vm._v("确认打卡"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("van-action-sheet", {
              attrs: {
                actions: _vm.keyuanList,
                "cancel-text": "取消",
                title: "请选择客源编号",
                "close-on-click-action": "",
              },
              on: { cancel: _vm.onCancel, select: _vm.onSelect },
              model: {
                value: _vm.show,
                callback: function ($$v) {
                  _vm.show = $$v
                },
                expression: "show",
              },
            }),
          ],
          1
        ),
      ])
    : _c("div", { staticClass: "container-renwu no" }, [_vm._v("暂无权限")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }